import { actions } from "../util/actions";

const initialState = {
  errorModal: {
    show: false,
    title: "Error",
    message: "",
    confirmLabel: undefined,
    status: "Failed",
  },
  globalLoading: {
    show: false,
    message: "",
  },
};

export const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SHOW_ERROR_MODAL: {
      const { title, message, confirmLabel, status } = action.payload || {};
      return {
        ...state,
        errorModal: {
          show: true,
          title: title || "Error",
          message: message || "",
          confirmLabel,
          status: status || "Failed",
        },
      };
    }
    case actions.HIDE_ERROR_MODAL: {
      return {
        ...state,
        errorModal: {
          ...state.errorModal,
          show: false,
          status: state.errorModal.status || "Failed",
        },
      };
    }
    case actions.SHOW_GLOBAL_LOADING: {
      const { message } = action.payload || {};
      return {
        ...state,
        globalLoading: {
          show: true,
          message: message || "Loading...",
        },
      };
    }
    case actions.HIDE_GLOBAL_LOADING: {
      return {
        ...state,
        globalLoading: {
          show: false,
          message: "",
        },
      };
    }
    default:
      return state;
  }
};
